import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Summary ??= {};

AppointmentBooking.Wizard.Views.Summary.AddressItem = class AddressItem extends (
  AppointmentBooking.Wizard.Views.Summary.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.model, "change:address", this.render);
  }
};
AppointmentBooking.Wizard.Views.Summary.AddressItem.prototype.template = "summary/address";
AppointmentBooking.Wizard.Views.Summary.AddressItem.prototype.className =
  "appointment-booking-wizard-summary-address-item";
